"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductDashboardProductManufacturer = void 0;
class ProductDashboardProductManufacturer {
}
exports.ProductDashboardProductManufacturer = ProductDashboardProductManufacturer;
//# sourceMappingURL=product-dashboard-product-manufacturer.response.js.map